import React from 'react'

export const ArrowLeftUp = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6085)'>
      <path
        d='M12.36 10.9471L18.018 16.6031L16.603 18.0181L10.947 12.3611L5.99701 17.3111V5.99707H17.31L12.36 10.9471Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6085'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
